<!-- Copyright (c) 2018 Cigent Technology Inc. All Rights Reserved. -->
<h2 id="EditLicenseCountDialog" mat-dialog-title>{{fHeader}}</h2>
<mat-dialog-content>
  <div class="type-field">
      <mat-label class="type-label">{{"organizations.sub.type_label" | translate}}</mat-label>
      <mat-select [(value)]="subType" class="type-selector" (selectionChange)="typeChanged($event)">
          <mat-option id="subType" *ngFor="let type of subTypes" [value]="type">
              {{"organizations.sub.type." + type.label | translate}}
        </mat-option>
      </mat-select>
  </div>

  <div mat-dialog-content class="edit-license-count-wrapper" appLifecycleTracker trackerName="edit-license-dialog">
      <button id="editLicensesSubtract" mat-mini-fab color="primary" aria-label="Subtract Licenses" (click)="clickedMinus()">
          -
      </button>
      &nbsp;
      <mat-form-field class="count-form-field" appearance="outline" [style.width.px]="data.total?.toString().length * 10 + 50">
          <mat-label>{{fCount}}</mat-label>
          <input [maxlength]="maxCount?.toString().length" [max]="maxCount" id="inputLicenseCount" matInput type="text" placeholder="{{fCount}}" [(ngModel)]="data.total"
              (keydown)="keyDown($event)" aria-label="Edit number of licenses." />
      </mat-form-field>
      &nbsp;
      <button id="editLicensesAdd" mat-mini-fab color="primary" aria-label="Add Licenses" (click)="clickedPlus()">
          +
      </button>
  </div>

  <div class="single-row">
      <mat-checkbox [(ngModel)]="data.enablePBAExtendedFeatures" color="primary">
        <span class="checkbox-with-icon">
          <span>{{'organizations.sub.enable-features-label' | translate}}</span>
          <span tabindex="0"
                aria-label="Includes TPM and non-interactive Security Key"
                matTooltip="Includes TPM and non-interactive Security Key"
                matTooltipPosition="right">
              <span class="mdi mdi-information-outline circle-info-icon"></span>
          </span>
        </span>
      </mat-checkbox>
  </div>

  <div class="single-row">
      <mat-checkbox [(ngModel)]="data.enablePBALogErase" color="primary" class="pba-features-checkbox">
      <span>{{'organizations.sub.enable-log-erase-label' | translate}}</span>
      </mat-checkbox>
  </div>

  <mat-divider class="divider"></mat-divider>

  <div mat-dialog-content>
      <mat-checkbox class="send-email-checkbox"  (change)="onNotifyCheckChanged($event)" color="primary">{{'EDIT_LICENSE_NOTIFY_ADMINS' | translate}}&nbsp;</mat-checkbox>
      <app-language-selector
          label=""
          [disabled]="!notifyAdminsByEmail"
          [selectedLanguage]="selectedLanguage"
          (valueChange)="onLanguageChanged($event)">
      </app-language-selector>
  </div>
</mat-dialog-content>
<div mat-dialog-actions class="button-wrapper">
    <button id="EditLicenseCountDialogCancel" mat-raised-button (click)="onCancelClick()" type="button">{{fCancel}}</button>
    <button id="EditLicenseCountDialogSave" mat-raised-button (click)="onSubmit()" color="primary" type="button">{{fSave}}</button>
</div>
